import { Nav } from '@dagens/carrot';
import { useNavLinksProducer } from '../../hooks/use-nav-links-producer';

export const BottomNavProducer = () => {
  const links = useNavLinksProducer();
  return <Nav.Tabs links={links} />;
};
